
import React from 'react';

const History: React.FC = () => {
  const milestones = [
    {
      year: '1990',
      title: 'Foundation of Toyo HI-TAK',
      description: 'Established Toyo HI-TAK with gun drilling machine manufacturing and sales as the main business.'
    },
    {
      year: '2008',
      title: 'HI-TAK Co., Ltd. Established',
      description: 'Founded HI-TAK Co., Ltd. and completed construction of headquarters factory in Matsunaga, Numazu City, Shizuoka Prefecture.'
    },
    {
      year: '2010',
      title: 'Hollow Servo Spindle Development',
      description: 'Developed hollow servo spindle with high rotational accuracy, enabling deep hole processing of difficult-to-cut materials that was previously impossible.'
    },
    {
      year: '2014',
      title: 'Small Diameter Gun Drilling Breakthrough',
      description: 'Developed new high-precision small diameter gun drilling machine, achieving deep hole processing from Φ0.5mm.'
    },
    {
      year: '2015',
      title: 'Kashiwa Group Partnership',
      description: 'Became part of Kashiwa Tec Co., Ltd. (now Kashiwa Group Co., Ltd.) group through M&A, strengthening business foundation.'
    },
    {
      year: '2016',
      title: 'Business Expansion & ISO Certification',
      description: 'Started external processing business with introduction of various machines (NC lathe, machining center, wire EDM, image dimension measuring machine). Obtained ISO 9001:2015 certification. Completed 2nd factory (current headquarters) in Nishikumado, Numazu City. Registered as medical device manufacturer.'
    },
    {
      year: '2017',
      title: 'World-Class Deep Hole Achievement',
      description: 'Developed automatic regrinding device for small diameter gun drills and new gun drilling machine capable of φ1mm × 400L deep hole processing. Selected as one of 300 promising SMEs and regional future traction companies.'
    },
    {
      year: '2020',
      title: 'Record-Breaking Precision',
      description: 'Achieved world\'s smallest gun drill processing of φ0.5mm with 60L depth. Completed new factory in Nishikumado, Numazu City and relocated headquarters functions.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#001E3C] mb-4">
            Company History
          </h2>
          <p className="text-xl text-gray-600">
            Three decades of innovation and excellence in precision manufacturing
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-[#00D9C9]"></div>
          
          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className={`flex items-center ${
                  index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'
                }`}
              >
                <div className={`w-1/2 ${index % 2 === 0 ? 'pr-12 text-right' : 'pl-12 text-left'}`}>
                  <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300">
                    <div className="text-3xl font-bold text-[#00D9C9] mb-2">
                      {milestone.year}
                    </div>
                    <h3 className="text-xl font-bold text-[#001E3C] mb-3">
                      {milestone.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {milestone.description}
                    </p>
                  </div>
                </div>
                
                <div className="relative z-10 flex items-center justify-center w-12 h-12 bg-[#00D9C9] rounded-full border-4 border-white shadow-lg">
                  <div className="w-3 h-3 bg-white rounded-full"></div>
                </div>
                
                <div className="w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default History;
